export const TemplateList = [
  { value: 1 ,label: 'テンプレートA' },
  { value: 2 ,label: 'テンプレートB' },
];